/**
 * @desc 获取获取Gj退货物流信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<any>, params: any, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/getGjCreateFulfillmentReturns`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
